<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="Basic-Paragraph ParaOverride-1" lang="en-US"><span class="CharOverride-1" lang="">Angélique Le Grand</span><span class="CharOverride-2" lang=""> is a licensed children’s therapist and mother of two adult children. She lives in the Netherlands and likes to run through misty forests, do yoga and swim in cold lakes. Due to a traumatic car accident right in front of her home, she wrote this children’s book. She searched for the best suitable illustrator to picture this emotional story but finally found her.</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-1" lang="">Nadine de Burlett </span><span class="CharOverride-2" lang="">is an illustrating artist, mother of three. Her motto is to slow down in life, to create slowly and to live slowly, for time is the most valuable luxury of this day and age. Nadine makes and captures moments in her art to do just that: to slow down, observe, and simply be in the present moment.</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt1.jpg"/>
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="c-heading" lang="en-US">Copyright © Angelique Le Grand 2024</p>
<p class="c-2nd-heading ParaOverride-3" lang="en-US">Illustrated by Nadine de Burlett</p>
<p class="c-normal ParaOverride-3" lang="en-US">The right of <span class="CharOverride-3" lang="">Angelique Le Grand</span> and <span class="CharOverride-3" lang="">Nadine de Burlett </span>to be identified as author and illustrator of this work has been asserted by them in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="c-normal ParaOverride-3" lang="en-US">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="c-normal ParaOverride-3" lang="en-US">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="c-normal ParaOverride-3" lang="en-US">A CIP catalogue record for this title is available from the British Library.</p>
<p class="c-normal" lang="en-US">ISBN 9781035803378 (Paperback)</p>
<p class="c-normal ParaOverride-3" lang="en-US">ISBN 9781035803392 (ePub e-book)</p>
<p class="c-normal ParaOverride-3" lang="en-US">www.austinmacauley.co.uk</p>
<p class="c-normal" lang="en-US">First Published 2024</p>
<p class="c-normal" lang="en-US">Austin Macauley Publishers Ltd®</p>
<p class="c-normal" lang="en-US">1 Canada Square </p>
<p class="c-normal" lang="en-US">Canary Wharf </p>
<p class="c-normal" lang="en-US">London</p>
<p class="c-normal _idGenParaOverride-1" lang="en-US">E14 5AA</p>
<p class="ded-next" lang="en-US">“How do you spell love?” Piglet</p>
<p class="ded ParaOverride-3" lang="en-US">“You don’t spell it. You feel it.” Pooh</p>
<p class="ded" lang="en-US">- A.A. Milne</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="image" lang="en-US"><img alt="" class="_idGenObjectAttribute-2" src="image/first.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer061">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer062">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt30.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt31.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt32.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer070">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer071">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt33.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer072">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer073">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt34.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer074">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer075">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt35.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer076">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer077">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt36.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer078">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer079">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt37.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer080">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer081">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt38.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer082">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer083">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt39.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer084">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer085">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt40.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer086">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer087">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer088">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer089">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt42.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer090">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer091">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt43.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer092">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer093">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt44.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer094">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer095">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt45.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer096">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer097">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt46.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer098">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer099">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt47.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer100">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer101">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt48.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer102">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer103">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt49.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer104">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer105">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt50.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer106">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer107">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt51.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer108">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer109">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt52.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer110">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer111">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt53.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer112">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer113">
<img alt="" class="_idGenObjectAttribute-1" src="image/9781035803378_txt54.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled6.vue?7b29983a